/* eslint-disable */
export default {
  region: 'Região',
  calling: 'Chamadas',
  logout: 'Fazer logout',
  version: 'Versão',
  settings: 'Configurações',
  selectToDialSMS: 'Selecione para discar/enviar SMS',
  selectToDial: 'Selecione para discar',
  selectToSMS: 'Selecione para enviar SMS',
  clickToDial: 'Clique para discar',
  autoCreateLog: 'Criar log de chamadas automaticamente',
  autoCreateSMSLog: 'Criar log de SMS automaticamente',
  autoLogCalls: 'Registrar chamadas automaticamente',
  autoLogNotes: 'Registrar notas automaticamente',
  autoLogSMS: 'Registrar SMS automaticamente',
  clickToSMS: 'Clicar para enviar SMS',
  logSMSContent: 'Registrar conteúdo de SMS',
  clickToDialSMS: 'Clique para discar/enviar SMS',
  logExtensionCall: 'Registrar chamadas do ramal',
  audio: 'Áudio',
  language: 'Idioma',
  feedback: 'Comentários',
  userGuide: 'Novidades',
  quickAccess: 'Configuração de acesso rápido',
  report: 'Relatório do Analytics',
  shareIdea: 'Compartilhar ideia',
  openEntityFrom: 'Comportamento do objeto do Salesforce',
  ctiPanelSize: 'Tamanho do painel de CTI',
  openInNewTab: 'Abrir em nova guia',
  openInCurrentTab: 'Abrir na guia atual',
  reportIssue: 'Relatar problema',
  contactSupport: 'Entrar em contato com o suporte',
  selectToDialHint:
    'Para ter a melhor experiência, selecione o número de telefone para discar com o RingCentral na página de números de telefone em grande quantidade.',
} as const;

// @key: @#@"region"@#@ @source: @#@"Region"@#@
// @key: @#@"calling"@#@ @source: @#@"Calling"@#@
// @key: @#@"logout"@#@ @source: @#@"Logout"@#@
// @key: @#@"version"@#@ @source: @#@"Version"@#@
// @key: @#@"settings"@#@ @source: @#@"Settings"@#@
// @key: @#@"selectToDialSMS"@#@ @source: @#@"Select to Dial/SMS"@#@
// @key: @#@"selectToDial"@#@ @source: @#@"Select to Dial"@#@
// @key: @#@"selectToSMS"@#@ @source: @#@"Select to SMS"@#@
// @key: @#@"clickToDial"@#@ @source: @#@"Click to Dial"@#@
// @key: @#@"autoCreateLog"@#@ @source: @#@"Auto-create Call Log"@#@
// @key: @#@"autoCreateSMSLog"@#@ @source: @#@"Auto-create SMS Log"@#@
// @key: @#@"autoLogCalls"@#@ @source: @#@"Auto log calls"@#@
// @key: @#@"autoLogNotes"@#@ @source: @#@"Auto log notes"@#@
// @key: @#@"autoLogSMS"@#@ @source: @#@"Auto log SMS"@#@
// @key: @#@"clickToSMS"@#@ @source: @#@"Click to SMS"@#@
// @key: @#@"logSMSContent"@#@ @source: @#@"Log SMS content"@#@
// @key: @#@"clickToDialSMS"@#@ @source: @#@"Click to Dial/SMS"@#@
// @key: @#@"logExtensionCall"@#@ @source: @#@"Log extension calls"@#@
// @key: @#@"audio"@#@ @source: @#@"Audio"@#@
// @key: @#@"language"@#@ @source: @#@"Language"@#@
// @key: @#@"feedback"@#@ @source: @#@"Feedback"@#@
// @key: @#@"userGuide"@#@ @source: @#@"What's New"@#@
// @key: @#@"quickAccess"@#@ @source: @#@"Quick Access Setting"@#@
// @key: @#@"report"@#@ @source: @#@"Analytics Report"@#@
// @key: @#@"shareIdea"@#@ @source: @#@"Share idea"@#@
// @key: @#@"openEntityFrom"@#@ @source: @#@"Salesforce object behavior"@#@
// @key: @#@"ctiPanelSize"@#@ @source: @#@"CTI panel size"@#@
// @key: @#@"openInNewTab"@#@ @source: @#@"Open in new tab"@#@
// @key: @#@"openInCurrentTab"@#@ @source: @#@"Open in current tab"@#@
// @key: @#@"reportIssue"@#@ @source: @#@"Report issue"@#@
// @key: @#@"contactSupport"@#@ @source: @#@"Contact support"@#@
// @key: @#@"selectToDialHint"@#@ @source: @#@"For your better experience, select phone number to dial with RingCentral in large quantity phone number page."@#@
